
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cool",
      function () {
        return require("private-next-pages/cool/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cool"])
      });
    }
  